export const response_ref = {
  description: 'Referenciales obtenidos exitosamente',
  shema: {
    type: 'object',
    properties: {
      message: { type: 'string', example: 'Referenciales obtenidos exitosamente' },
      data: {
        geografica: {
          type: 'object',
          properties: {
            paises: { type: 'array' },
            ciudades: { type: 'array' },
            barrios: { type: 'array' },
            distritos: { type: 'array' },
            departamentos: { type: 'array' },
          },
        },
        actividad_economicas_sifen: { type: 'array' },
        afectacion_iva: { type: 'array' },
        condicion_negociacion: { type: 'array' },
        condicion_operacion: { type: 'array' },
        condicion_operacion_credito: { type: 'array' },
        forma_procesamiento_pago: { type: 'array' },
        forma_pago: { type: 'array' },
        motivos_autofactura: { type: 'array' },
        monedas: { type: 'array' },
        indicador_presencia: { type: 'array' },
        unidades_de_medida: { type: 'array' },
        modalidad_transporte: { type: 'array' },
        marca_tarjetas: { type: 'array' },
        motivo_emision_nota_credito_y_debito: { type: 'array' },
        motivo_emision_remision: { type: 'array' },
        naturaleza_receptor: { type: 'array' },
        responsable_emision: { type: 'array' },
        tarjeta: { type: 'array' },
        tipo_anticipo: { type: 'array' },
        tipo_constancia: { type: 'array' },
        tipo_credito: { type: 'array' },
        tipo_contribuyente: { type: 'array' },
        tipo_doc_asoc: { type: 'array' },
        tipo_documento: { type: 'array' },
        tipo_documento_identidad: { type: 'array' },
        tipo_documento_impreso: { type: 'array' },
        tipo_identificacion: { type: 'array' },
        tipo_impuesto: { type: 'array' },
        tipo_movimiento_cajas: { type: 'array' },
        tipo_obligacion: { type: 'array' },
        tipo_operacion: { type: 'array' },
        tipo_pago: { type: 'array' },
        tipo_transaccion: { type: 'array' },
        tipo_transporte: { type: 'array' },
      },
    },
  },
};
